import { render, staticRenderFns } from "./AssignmentNew.vue?vue&type=template&id=308b1840"
import script from "./AssignmentNew.vue?vue&type=script&lang=js"
export * from "./AssignmentNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports